module.exports = __webpack_public_path__ + "img/img-2.df6f059.jpg";